export default __webpack_public_path__ + "static/media/empty.1bb5dfba.png";